import { useNavigate } from "react-router-dom";

interface Props {
  initialKeyword: string;
}

export default function SearchBar({ initialKeyword }: Props) {
  const navigate = useNavigate();

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const value = String(data.get("q") || "").trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
  };

  return (
    <form onSubmit={onSubmit} className="flex flex-col sm:flex-row items-stretch gap-2" role="search" data-readdy-form="search">
      <div className="relative flex-1">
        <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400" />
        <input
          type="search"
          name="q"
          defaultValue={initialKeyword}
          placeholder="输入漫画名称、作者、题材关键词"
          aria-label="搜索漫画关键词"
          className="w-full h-11 pl-11 pr-4 rounded-md bg-background-900/80 border border-background-700/70 text-sm text-foreground-100 placeholder:text-foreground-500 outline-none focus:border-accent-400/80 transition-colors"
        />
      </div>
      <button
        type="submit"
        className="h-11 px-6 rounded-md bg-accent-500 text-background-950 text-sm font-medium flex items-center justify-center gap-1.5 hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-search-line" />
        搜索
      </button>
    </form>
  );
}